import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { docView } from "../../API/DocView";
import { docViewADM } from "../../AdminAPI/DocViewADM";
import { getJdata } from "../../API/DocJdata";
import { getJdataADM } from "../../AdminAPI/DocJdataADM";
import { docUpdate } from "../../API/DocUpdate";
import { docUpdateADM } from "../../AdminAPI/DocUpdateADM";
import i18n from "../../Langues/i18n"

// Utilisation de Set pour sélectionner les documents cochés
export const handleCheckboxChange = (
  event,
  DocId,
  selectedDocuments,
  setSelectedDocuments
) => {
  const isChecked = event.target.checked;
  const newSelectedDocuments = new Set(selectedDocuments);

  if (isChecked) {
    newSelectedDocuments.add(DocId);
  } else {
    newSelectedDocuments.delete(DocId);
  }

  setSelectedDocuments([...newSelectedDocuments]);
};

//update les éléments selected
export const handleUpdateSelected = async (
  selectedDocuments,
  setSelectedDocuments,
  data,
  instanceId
) => {
  let errcount = 0;
  for (const DocId of selectedDocuments) {
    try {
      await handleSubmitChange(DocId, data, instanceId);
    } catch (error) {
      errcount++;
    }
  }

  if (errcount !== 0) {
    toast.error(
      i18n.t("Error(s) while updating documents", { errcount }),
      {
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
    );
  } else {
    toast.success(i18n.t("Data updated successfully"), {
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    setSelectedDocuments([]);
    window.location.reload();
  }
};

// Gère le changement de fichier sélectionné et met à jour les états correspondants
export const handleFileChange = (e, setSelectedFile, setFileExtension) => {
  const file = e.target.files[0];
  if (file) {
    setSelectedFile(file);
    const fileName = file.name;
    const fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
    setFileExtension(fileExt);
  }
};

// Gère le changement du nombre d'éléments par page
export const handleItemsPerPageChange = (event, setItemPerPage) => {
  setItemPerPage(Number(event.target.value));
};

// Gère les changements d'entrée et met à jour les états correspondants
export const handleInputChange = (
  event,
  DocId,
  key,
  setSelectedDocuments,
  data,
  setData
) => {
  const { value, type, checked } = event.target;
  if (type === "checkbox") {
    if (checked) {
      setSelectedDocuments((prevSelected) => [...prevSelected, DocId]);
    } else {
      setSelectedDocuments((prevSelected) =>
        prevSelected.filter((id) => id !== DocId)
      );
    }
  } else {
    const newValue = key === "isvalid" ? event.target.value === "true" : value;
    const newData = data.map((item) => {
      if (item.DocId === DocId) {
        const updatedItem = { ...item, [key]: newValue };
        const isAnyFieldModified = Object.keys(updatedItem).some(
          (field) => field !== "DocId" && item[field] !== updatedItem[field]
        );
        if (isAnyFieldModified) {
          setSelectedDocuments((prevSelected) => [...prevSelected, DocId]);
        } else {
          setSelectedDocuments((prevSelected) =>
            prevSelected.filter((id) => id !== DocId)
          );
        }
        return updatedItem;
      }
      return item;
    });
    setData(newData);
  }
};

// Gère la soumission des modifications et met à jour les états correspondants
export const handleSubmitChange = async (DocId, data, instanceId) => {
  const updatedItem = data.find((item) => item.DocId === DocId);
  if (updatedItem) {
    const { Complexite, Priorite, isvalid } = updatedItem;
    const idToken = Cookies.get("Token");
    const role = Cookies.get("Role");
    const clientId = Cookies.get("clientId");
    let response;
    try {
      if (role === "superadmin"){
        response = await docUpdateADM(idToken, instanceId, DocId, Complexite, Priorite, isvalid, clientId);
      } else {
        response = await docUpdate(idToken, instanceId, DocId, Complexite, Priorite, isvalid);
      }
      window.location.reload();
    } catch (error) {
      console.error("Erreur lors de la mise à jour des données", error);
    }
  }
};

// Fonction pour récupérer les modèles de données
export const ViewDocument = (docId, modelId, instanceId, clientId) => {
  const token = Cookies.get("Token");
  const role = Cookies.get("Role");
  if (role === "superadmin"){
    docViewADM(token, docId, modelId, instanceId, clientId)
  }else {
    docView(token, docId, modelId, instanceId);
  }
};

// Fonction pour récupérer lej data dun document
export const callGetJData = (instanceId, docId, clientId) => {
  const token = Cookies.get("Token");
  const role = Cookies.get("Role");
  if (role === "superadmin"){
    getJdataADM(instanceId, docId, token, clientId)
  }else {
    getJdata(instanceId, docId, token);
  }
};

//affichage d'un modal pour jinput
export const displayInputData = (inputData) => {
  const existingModals = document.querySelectorAll("#input-modal, #json-modal");
  existingModals.forEach((modal) => modal.remove());

  if (document.getElementById("input-modal")) return;

  const modal = document.createElement("div");
  modal.id = "input-modal";
  modal.style.position = "fixed";
  modal.style.top = "0";
  modal.style.left = "0";
  modal.style.width = "100%";
  modal.style.height = "100%";
  modal.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
  modal.style.display = "flex";
  modal.style.alignItems = "center";
  modal.style.justifyContent = "center";
  modal.style.zIndex = "9999";

  const jsonContainer = document.createElement("pre");
  jsonContainer.style.backgroundColor = "#333333";
  jsonContainer.style.color = "#ffffff";
  jsonContainer.style.padding = "20px";
  jsonContainer.style.overflow = "auto";
  jsonContainer.style.maxWidth = "80%";
  jsonContainer.style.maxHeight = "80%";
  jsonContainer.style.borderRadius = "5px";
  jsonContainer.style.boxShadow = "0 0 10px rgba(0, 0, 0, 0.3)";

  try {
    const parsedData =
      typeof inputData === "string" ? JSON.parse(inputData) : inputData;
    jsonContainer.textContent = JSON.stringify(parsedData, null, 0)
      .replace(/{/g, "{ ")
      .replace(/}/g, " }")
      .replace(/:/g, ": ")
      .replace(/,/g, ", ");
  } catch (error) {
    console.error("Erreur de parsing JSON :", error);
    jsonContainer.textContent = "Erreur : Format JSON invalide";
  }

  modal.appendChild(jsonContainer);
  document.body.appendChild(modal);

  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      document.body.removeChild(modal);
    }
  });
};

// Affichage d'un modal pour JError
export const displayErrorData = (errorData) => {
  // Supprime les modals existants pour éviter les doublons
  const existingModals = document.querySelectorAll("#input-modal, #json-modal, #error-modal");
  existingModals.forEach((modal) => modal.remove());

  if (document.getElementById("error-modal")) return;

  const modal = document.createElement("div");
  modal.id = "error-modal";
  modal.style.position = "fixed";
  modal.style.top = "0";
  modal.style.left = "0";
  modal.style.width = "100%";
  modal.style.height = "100%";
  modal.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
  modal.style.display = "flex";
  modal.style.alignItems = "center";
  modal.style.justifyContent = "center";
  modal.style.zIndex = "9999";

  const errorContainer = document.createElement("pre");
  errorContainer.style.backgroundColor = "#333333";
  errorContainer.style.color = "#ffffff";
  errorContainer.style.padding = "20px";
  errorContainer.style.overflow = "auto";
  errorContainer.style.maxWidth = "80%";
  errorContainer.style.maxHeight = "80%";
  errorContainer.style.borderRadius = "5px";
  errorContainer.style.boxShadow = "0 0 10px rgba(0, 0, 0, 0.5)";
  errorContainer.style.whiteSpace = "pre-wrap";
  errorContainer.style.wordBreak = "break-word";

  try {
    const parsedData =
      typeof errorData === "string" ? JSON.parse(errorData) : errorData;
    errorContainer.textContent = JSON.stringify(parsedData, null, 2)
      .replace(/{/g, "{ ")
      .replace(/}/g, " }")
      .replace(/:/g, ": ")
      .replace(/,/g, ", ");
  } catch (error) {
    console.error("Erreur de parsing JSON :", error);
    errorContainer.textContent = typeof errorData === "string" ? errorData : "Erreur : données invalides";
  }

  modal.appendChild(errorContainer);
  document.body.appendChild(modal);

  // Fermeture du modal au clic
  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      document.body.removeChild(modal);
    }
  });
};
